/**
 * Host adapter context — exposed to lib internals via `useSourcesHost()`.
 *
 * The host adapter is provided once by `<SourcesProvider>` and read by
 * every component and hook inside the lib. This is the single
 * dependency-inversion seam between the shared UI and per-app wiring.
 */
import { createContext, useContext } from 'react';
import type { SourcesHost } from '../types/host';

const SourcesHostContext = createContext<SourcesHost | null>(null);

export function SourcesHostProvider({
  host,
  children,
}: {
  host: SourcesHost;
  children: React.ReactNode;
}) {
  return (
    <SourcesHostContext.Provider value={host}>
      {children}
    </SourcesHostContext.Provider>
  );
}

export function useSourcesHost(): SourcesHost {
  const host = useContext(SourcesHostContext);
  if (!host) {
    throw new Error(
      '[sources-ui] useSourcesHost() must be called inside <SourcesProvider>',
    );
  }
  return host;
}
